import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import styles from './ButtonsStyles.module.scss';
import { botAiProvider } from '../ChatBotAI';

export const SendScreenshotButton = () => {
  const [enabled, setEnabled] = useState(botAiProvider.includeScreenshot);
  const { t } = useTranslation();

  const toggleScreenshot = () => {
    const newValue = !enabled;
    setEnabled(newValue);

    if (typeof botAiProvider.setIncludeScreenshot === 'function') {
      botAiProvider.setIncludeScreenshot(newValue);
    } else {
      console.error('setIncludeScreenshot is not a function on botAiProvider');
    }
  };

  return (
    <button
      onClick={toggleScreenshot}
      className={`rcb-attach-button-enabled ${styles.SendScreenshotButton}`}
      title={t('cartAI.toggleScreenShot')}
    >
      {enabled ? <VisibilityOffIcon /> : <VisibilityIcon />}
    </button>
  );
};
